import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'A hierarchy of institutional units such as colleges, divisions, and departments. Different institutions may record assignments at the division level, department level, or more granular levels.',
    name: 'Organization',
    partialId: PartialId.Standard.create('org'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
